import script from "./EditUserTableRow.vue?vue&type=script&setup=true&lang=js"
export * from "./EditUserTableRow.vue?vue&type=script&setup=true&lang=js"

import "./EditUserTableRow.vue?vue&type=style&index=0&id=5b3c7cae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b3c7cae"]])

export default __exports__